module.exports = __webpack_public_path__ + "img/wide.1cb88a8e.jpg";